import {DataStatus} from 'platform/components';
import {Center} from 'platform/foundation';

import {isNil} from 'ramda';

import {
  buildUrl,
  getWorkspaceFromUri,
  iamQueryParams,
  iamRedirectRoute,
  redirectToLogin,
} from '@dms/routes';

import {useBoolean, useOnMount, useQueryState} from 'shared/web';

export function UserInvitationRedirect() {
  const [email] = useQueryState('email');
  const [id] = useQueryState('id');
  const {workspace} = getWorkspaceFromUri();

  const [isError, triggerError] = useBoolean();

  useOnMount(() => {
    const redirectUrl = `${buildUrl(iamRedirectRoute, workspace, false)}?${iamQueryParams.ORIGIN_URI}=${encodeURIComponent(window.location.origin)}`;

    if (isNil(workspace) || isNil(id)) {
      triggerError();
      return;
    }

    redirectToLogin({
      page: 'user-invitation',
      currentUserEmail: email ? email : undefined,
      additionalQueryParams: {invitationId: id},
      redirectUrl,
    });
  });

  return (
    <Center height="100vh" width="100%">
      <DataStatus isLoading isError={isError} />
    </Center>
  );
}
